import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstadosDocumentoService {

  private apiUrl = `${environment.apiUrl}/api/estados-documento`;

  constructor(private http: HttpClient) { }

  getAllEstados(): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl,
      { withCredentials: true }
    );
  }

  getEstadoById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    );
  }

  createEstado(data: any): Observable<any> {
    return this.http.post<any>(
      this.apiUrl,
      data,
      { withCredentials: true }
    );
  }

  updateEstado(id: number, data: any): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/${id}`,
      data,
      { withCredentials: true }
    );
  }

  deleteEstado(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    );
  }

}